export default "__VITE_ASSET__01a7018c__"